import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import { GiRotaryPhone } from "react-icons/gi";
import { MdEmail, MdFax } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { BlogsSlider } from "../Slider/BlogsSlider";
import { API } from "../api";

const blogs = [
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
];

const Contact = () => {
  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const navigate = useNavigate();

  // Form state
  const [formData, setFormData] = useState({
    subject: "",
    company: "",
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
    message: "",
    status: false
  });

  // Fetch contact data from API
  const fetchContactData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API}/api/contact`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch contact data");
      }

      const data = await response.json();

      if (data) {
        console.log(data);
        setContactData(data);
      } else {
        throw new Error("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching contact data:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContactData();
    AOS.init({ duration: 1000 });
  }, []);

  // Helper function to get media URL
  const getMediaUrl = (mediaObject) => {
    if (mediaObject.id) {
      return `${API}/api/media/${mediaObject.id}`;
    } else {
      return `${API}/api/media/${mediaObject}`;
    }
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));

    // Clear error when user starts typing
    if (formErrors[id]) {
      setFormErrors(prev => ({
        ...prev,
        [id]: ""
      }));
    }
  };

  // Form validation
  const validateForm = () => {
    const errors = {};

    if (!formData.firstName.trim()) {
      errors.firstName = "First Name is required";
    }

    if (!formData.lastName.trim()) {
      errors.lastName = "Last Name is required";
    }

    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email is invalid";
    }

    if (!formData.contact.trim()) {
      errors.contact = "Contact number is required";
    } else if (!/^\d{10}$/.test(formData.contact.replace(/\D/g, ''))) {
      errors.contact = "Contact number must be 10 digits";
    }

    if (!formData.message.trim()) {
      errors.message = "Message is required";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        title: "Validation Error",
        text: "Please fill all required fields correctly",
        icon: "error",
        confirmButtonColor: "#F47024"
      });
      return;
    }

    setSubmitting(true);

    try {
      const submitData = {
        ...formData,
        contact: formData.contact.replace(/\D/g, '') // Remove non-digit characters
      };

      const response = await fetch(`${API}/api/contact-us`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        body: JSON.stringify(submitData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to submit form");
      }

      const result = await response.json();

      // Show success message
      Swal.fire({
        title: "Success!",
        text: "Your message has been sent successfully. We'll get back to you soon!",
        icon: "success",
        confirmButtonColor: "#F47024"
      });

      // Reset form
      setFormData({
        subject: "",
        company: "",
        firstName: "",
        lastName: "",
        email: "",
        contact: "",
        message: "",
        status: false
      });
      setFormErrors({});

    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        title: "Error!",
        text: error.message || "Failed to send message. Please try again.",
        icon: "error",
        confirmButtonColor: "#F47024"
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error && !contactData) {
    return (
      <div className="alert alert-warning m-3" role="alert">
        Error loading contact data: {error}
      </div>
    );
  }

  return (
    <div>
      <div class="pageBg">
        <div class="col-11 m-auto">
          <br />
          <div class="d-flex align-items-center mt-5">
            <div class="text-start">
              <p class=" display-4" data-aos="fade-up">
                {contactData?.pageHeader?.titleLine1}
              </p>
              <p
                class="display-4 org fw-semibold line-height-1"
                data-aos="fade-up"
              >
                {contactData?.pageHeader?.titleLine2}
              </p>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-end mt-3">
            <div class="col-md-8  text-start">
              <p class="fs-5 tJustify" data-aos="fade-up">
                {contactData?.pageHeader?.description}
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div
              class="col-11 m-auto p-3  text-start mt-5 bg-white"
              data-aos="zoom-in-up"
              style={{ border: "2px solid #f47024" }}
            >
              <p class="fs-1 fw-semibold org">{contactData?.formSection?.title}</p>
              <div
                style={{ width: "100%", height: "2px", background: "#f47024" }}
              ></div>

              <div class="mt-3">
                <label htmlFor="subject" class="fw-bold fs-5 org">
                  Subject
                </label>
                <input
                  id="subject"
                  type="text"
                  class="form-control rounded-0"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                />
              </div>

              <div class="mt-3">
                <label htmlFor="company" class="fw-bold fs-5 org">
                  Company
                </label>
                <input
                  id="company"
                  type="text"
                  class="form-control rounded-0"
                  placeholder="Your Company"
                  value={formData.company}
                  onChange={handleInputChange}
                />
              </div>

              <div class="row justify-content-between m-0">
                <div class="col-lg-6 p-0">
                  <div class="mt-3">
                    <label htmlFor="firstName" class="fw-bold fs-5 org">
                      First Name *
                    </label>
                    <input
                      id="firstName"
                      type="text"
                      class={`form-control rounded-0 ${formErrors.firstName ? 'is-invalid' : ''}`}
                      placeholder="Enter Your First Name"
                      value={formData.firstName}
                      onChange={handleInputChange}
                    />
                    {formErrors.firstName && (
                      <div class="invalid-feedback d-block">
                        {formErrors.firstName}
                      </div>
                    )}
                  </div>
                </div>
                <div class="col-lg-5 p-0">
                  <div class="mt-3 ">
                    <label htmlFor="lastName" class="fw-bold fs-5 org">
                      Last Name *
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      class={`form-control rounded-0 ${formErrors.lastName ? 'is-invalid' : ''}`}
                      placeholder="Enter Your Last Name"
                      value={formData.lastName}
                      onChange={handleInputChange}
                    />
                    {formErrors.lastName && (
                      <div class="invalid-feedback d-block">
                        {formErrors.lastName}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div class="row justify-content-between m-0">
                <div class="col-lg-6 p-0">
                  <div class="mt-3">
                    <label htmlFor="email" class="fw-bold fs-5 org">
                      Email *
                    </label>
                    <input
                      id="email"
                      type="email"
                      class={`form-control rounded-0 ${formErrors.email ? 'is-invalid' : ''}`}
                      placeholder="Enter Your Email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                    {formErrors.email && (
                      <div class="invalid-feedback d-block">
                        {formErrors.email}
                      </div>
                    )}
                  </div>
                </div>
                <div class="col-lg-5 p-0">
                  <div class="mt-3 ">
                    <label htmlFor="contact" class="fw-bold fs-5 org">
                      Contact *
                    </label>
                    <input
                      id="contact"
                      type="tel"
                      class={`form-control rounded-0 ${formErrors.contact ? 'is-invalid' : ''}`}
                      placeholder="Enter Your Contact Number"
                      value={formData.contact}
                      onChange={handleInputChange}
                      maxLength="10"
                    />
                    {formErrors.contact && (
                      <div class="invalid-feedback d-block">
                        {formErrors.contact}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div class="mt-3">
                <label htmlFor="message" class="fw-bold fs-5 org">
                  Message *
                </label>
                <textarea
                  id="message"
                  class={`form-control rounded-0 ${formErrors.message ? 'is-invalid' : ''}`}
                  placeholder="Enter Your Message"
                  rows="4"
                  value={formData.message}
                  onChange={handleInputChange}
                />
                {formErrors.message && (
                  <div class="invalid-feedback d-block">
                    {formErrors.message}
                  </div>
                )}
              </div>

              <button
                type="submit"
                className="buttonEffect mb-2"
                disabled={submitting}
              >
                {submitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Rest of your contact sections remain the same */}
      <div class="bgorg mt-5">
        <br />
        <div class="text-start col-11 m-auto">
          <p class="fw-bold fs-1 text-white">Get in Touch</p>

          {/* First Contact Section */}
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <img
                data-aos="zoom-in"
                src={getMediaUrl(contactData?.contactSections?.[0]?.image)}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                alt="Contact"
                loading="lazy"
                crossOrigin="anonymous"
              />
            </div>
            <div class="col-lg-9 col-md-6">
              <div class=" bg-white h-100 p-3" data-aos="fade-left">
                <p class="fs-2 fw-bold org">{contactData?.contactSections?.[0]?.title}</p>
                <div
                  style={{
                    width: "100%",
                    height: "2px",
                    background: "#f47024",
                  }}
                ></div>
                <br />
                <div class="d-flex align-items-end justify-content-between  fs-5 flex-wrap">
                  <div>
                    <div class="d-flex align-items-center gap-2">
                      <GiRotaryPhone class="fs-5 org" />: <p>{contactData?.contactSections?.[0]?.phone}</p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <MdFax class="fs-5 org" />: <p> {contactData?.contactSections?.[0]?.fax} </p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class=" org">CIN </p> <p>: {contactData?.contactSections?.[0]?.cin}</p>
                    </div>
                    <div class="d-flex align-items-start gap-2">
                      <p class=" org">Add </p>{" "}
                      <p>
                        : {contactData?.contactSections?.[0]?.address}
                      </p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <MdEmail class="fs-5 org" /> <p>: {contactData?.contactSections?.[0]?.email}</p>
                    </div>
                  </div>
                  <div>
                    <button className="buttonEffect mb-2" onClick={() => navigate(contactData?.contactSections?.[0]?.button?.link)}>
                      {contactData?.contactSections?.[0]?.button?.label}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Second Contact Section */}
          <div class="row mt-4 flex-column-reverse flex-md-row ">
            <div class="col-lg-9 col-md-6">
              <div class=" bg-white h-100 p-3" data-aos="fade-right">
                <p class="fs-2 fw-bold org">{contactData?.contactSections?.[1]?.title}</p>
                <div
                  style={{
                    width: "100%",
                    height: "2px",
                    background: "#f47024",
                  }}
                ></div>
                <br />
                <div class="d-flex align-items-end justify-content-between  fs-5 flex-wrap">
                  <div>
                    <div class="d-flex align-items-center gap-2">
                      <GiRotaryPhone class="fs-5 org" />{" "}
                      <p>: {contactData?.contactSections?.[1]?.phone}</p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <MdFax class="fs-5 org" /> <p>: {contactData?.contactSections?.[1]?.fax} </p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class=" org">CIN</p> <p>: {contactData?.contactSections?.[1]?.cin}</p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class=" org">ADD </p>{" "}
                      <p>
                        : {contactData?.contactSections?.[1]?.address}
                      </p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <MdEmail class="fs-5 org" /> <p>: {contactData?.contactSections?.[1]?.email}</p>
                    </div>
                  </div>
                  <div>
                    <button className="buttonEffect mb-2" onClick={() => navigate(contactData?.contactSections?.[1]?.button?.link)} >
                      {contactData?.contactSections?.[1]?.button?.label}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <img
                data-aos="zoom-in"
                src={getMediaUrl(contactData?.contactSections?.[1]?.image)}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                alt="Contact"
                loading="lazy"
                crossOrigin="anonymous"
              />
            </div>
          </div>

          <br />
          <br />
        </div>
      </div>

      <div class="mt-4">
        <div class="col-11 m-auto text-start">
          <p class="fs-5" data-aos="fade-up">
            Updates
          </p>
          <p class="fs-1 fw-semibold " data-aos="fade-up">
            The latest from{" "}
          </p>
          <p class="fs-1 fw-bold org line-height-1 mb-2" data-aos="fade-up">
            Ladderup
          </p>
          <div className="d-flex gap-3" data-aos="fade-up"></div>
        </div>
        <div data-aos="fade-up">
          <BlogsSlider data={blogs} />
        </div>
      </div>
    </div>
  );
};

export default Contact;